/* global google */
import React from 'react';
import { compose, withProps, withHandlers, withState } from 'recompose';
import { withGoogleMap, GoogleMap } from 'react-google-maps';
//
import { MAP_PARAMS } from 'config/constants';
import { Markers } from './Markers';
import mapStyle from './mapStyle.json';

import './index.scss';

export const MapWithList = compose(
  withProps({
    loadingElement: <div style={{ height: '100%' }} />,
    containerElement: <div style={{ height: 'calc(100vh - 94px)' }} />,
    mapElement: <div style={{ height: '100%' }} />,
  }),
  withState('zoom', 'setZoom', MAP_PARAMS.DEFAULT_ZOOM),
  withState('center', 'setCenter', MAP_PARAMS.DEFAULT_CENTER),
  withHandlers(() => {
    const refs = {
      map: undefined,
    };

    return {
      onMapMounted: () => (ref) => (refs.map = ref),
      handleClustererMarkerClick: ({
        handleClustererMarkerClick,
        setZoom,
        setCenter,
        zoom,
      }) => handleClustererMarkerClick(refs, setZoom, setCenter, zoom),
      onCenterChanged: ({ handleMapChange, setZoom }) =>
        handleMapChange(refs, setZoom),
      onZoomChanged: ({ handleMapChange, setZoom, zoom }) =>
        handleMapChange(refs, setZoom, zoom),
    };
  }),
  withGoogleMap,
)(
  ({
    listMapData = [],
    onMapClick,
    onMarkerClick,
    handleClustererMarkerClick,
    isInfoProcessed,
    openedInfoBox,
    activeLocationData,
    defaultCenter,
    activeLocationId,
    activeMarkerImg,
    onMouseOver,
    onMouseOut,
    onZoomChanged,
    onMapMounted,
    onCenterChanged,
    zoom,
    center,
  }) => (
    <GoogleMap
      defaultZoom={MAP_PARAMS.DEFAULT_ZOOM}
      defaultCenter={{ lat: defaultCenter.x, lng: defaultCenter.y }}
      defaultOptions={{ styles: mapStyle, minZoom: MAP_PARAMS.DEFAULT_ZOOM }}
      onClick={onMapClick}
      onZoomChanged={onZoomChanged}
      zoom={zoom}
      center={center}
      onCenterChanged={onCenterChanged}
      ref={onMapMounted}
    >
      <Markers
        listData={listMapData}
        onMouseOver={onMouseOver}
        onMouseOut={onMouseOut}
        activeLocationId={activeLocationId}
        openedInfoBox={openedInfoBox}
        activeMarkerImg={activeMarkerImg}
        onMarkerClick={onMarkerClick}
        handleClustererMarkerClick={handleClustererMarkerClick}
        activeLocationData={activeLocationData}
        isInfoProcessed={isInfoProcessed}
      />
    </GoogleMap>
  ),
);
